import React, { Component } from 'react'
import { connect } from 'react-redux'
import { VERIFY_EMAIL_REQUEST } from '../../actions/actions'
import { Jumbotron } from '@sketchpixy/rubix'
import { Link, browserHistory } from 'react-router'
import { appendToFormData } from '../../helpers/utility'

const styles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
}

class VerifyEmailPage extends Component {
  componentWillMount = () => {
    this.checkForPrevAuth()
  }

  checkForPrevAuth = () => {
    const {
      dispatch,
      params: { token },
    } = this.props

    const prevAuthInfo = localStorage.getItem('fpAuth')

    if (!prevAuthInfo) {
      browserHistory.push('/dashboard/profile')
      return
    }

    const parsedInfo = JSON.parse(prevAuthInfo)

    if (!parsedInfo) {
      browserHistory.push('/dashboard/profile')
      return
    }

    dispatch({
      type: VERIFY_EMAIL_REQUEST,
      formData: appendToFormData({ token }),
      authToken: parsedInfo.token,
    })
  }

  render() {
    return (
      <div>
        <Jumbotron style={styles}>
          <h3>ایمیل شما تایید شد</h3>
          <Link to="/dashboard">بازگشت</Link>
        </Jumbotron>
      </div>
    )
  }
}

export default connect()(VerifyEmailPage)



// WEBPACK FOOTER //
// ./src/components/authentication/VerifyEmailPage.js